/**
 * @param {Object[]} collection
 * @param {String} key
 *
 * @return {Object}
 */
export function keyBy(collection, key = 'key') {
  const keyed = {};

  Object.values(collection ?? {}).forEach((item) => {
    keyed[item[key]] = item;
  });

  return keyed;
}

/**
 * @param {Object[]} collection
 * @param {String} collection[].uuid
 *
 * @return {Object}
 */
export function keyById(collection) {
  const key = collection?.[0]?.id ? 'id' : 'uuid';
  return keyBy(collection, key);
}
